<template>
  <div
    class="listComponentWrapper"
    :class="{ navigating, selected }"
    @click="toggle"
  >
    <div class="pictureWrapper">
      <images_mosaic
        v-if="pictures.length > 1"
        :pictures="pictures"
        class="picture"
      />
      <img v-else-if="pictures.length" class="picture" :src="pictures[0]" />
      <div v-else class="placeholder">
        <i class="fas fa-bookmark" />
      </div>
      <div
        v-if="!navigating"
        class="addedOverlay"
        :class="{ overlayVisible: bookmarked }"
      />
      <div v-if="!navigating" class="hoverOverlay" />
      <i v-if="!navigating" class="fa-bookmark overlay" :class="bookmarkIcon" />
    </div>
    <div class="textWrap">
      <span class="listTitle ellipsis">{{ bucket.name }}</span>
      <span class="listSubtitle">{{ listSubtitle }} </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import images_mosaic from "~/components/images/mosaic"

import picture_build_helper from "~/helpers/images/picture_build"

export default {
  components: {
    images_mosaic,
  },
  data: function () {
    return {
      loading: true,
      bookmarked: false,
    }
  },
  mounted: async function () {
    /*await this.fetchInfluencers();*/

    if (this.infIsInBucket) this.bookmarked = true
  },
  computed: {
    ...mapGetters({
      GET_INFLUENCER_BY_ID: "influencers/GET_BY_ID",
    }),
    infIsInBucket: function () {
      return this.bucket.influencers.includes(this.influencer_id)
    },
    influencers: function () {
      return this.bucket.influencers.reduce((accumulator, influencer_id) => {
        const influencer = this.GET_INFLUENCER_BY_ID(influencer_id)

        if (influencer) accumulator.push(influencer)
        return accumulator
      }, [])
    },
    pictures: function () {
      return this.influencers.map((influencer) => {
        return picture_build_helper({
          kind: "influencer",
          slug: influencer.has_profile_picture ? influencer.slug : undefined,
          target: "profile_picture",
          size: "400_400",
        })
      })
    },
    bookmarkIcon: function () {
      return this.bookmarked ? "bookmarked fas" : "far"
    },
    listSubtitle: function () {
      return `${this.influencers.length} ${this.$tc(
        "common.multi_inf",
        this.influencers.length
      )}`
    },
    selected: function () {
      return this.bucket.id === this.selected_bucket_id
    },
  },
  methods: {
    toggle: function () {
      if (!this.navigating) this.bookmarked = !this.bookmarked
      this.$emit("bucket", this.bookmarked, this.bucket.id)
    },
    fetchInfluencers: function () {
      this.$axios
        .$get(
          `/influencer/filter/?query=favorites&favorites_id=${this.bucket.id}`
        )
        .then(({ results }) => {
          this.$set(this, "influencers", results || [])
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  props: {
    bucket: {
      type: Object,
      required: true,
    },
    influencer_id: {
      type: Number,
      required: false,
    },
    navigating: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      },
    },
    selected_bucket_id: {
      type: Number,
      required: false,
    },
  },
}
</script>

<style scoped src="./elem.css"></style>
<style scoped src="./elem1024.css"></style>
<style scoped src="./elem768.css"></style>
<style scoped src="./elem480.css"></style>
